import React from 'react'

type CategoriesProps = {
    value: number
    onChangeCategory: (index: number) => void
}

const categories = ['Все', 'Мясные', 'Вегетарианские', 'Гриль', 'Острые', 'Закрытые']

export const Categories: React.FC<CategoriesProps> = React.memo(({ value, onChangeCategory }) => {
    return (
        <div className='categories'>
            <ul>
                {categories.map((categoryName, index) => (
                    <li
                        key={index}
                        onClick={() => onChangeCategory(index)}
                        className={value === index ? 'active' : ''}
                    >
                        {categoryName}
                    </li>
                ))}
            </ul>
        </div>
    )
})

Categories.displayName = 'Categories'
